import { Icons } from "../components/common/Icons";

// Static UI config (not from DB)
const sidebarItems = [
  { key:"dashboard", label:"Dashboard", icon:Icons.Dashboard },
  { key:"profile", label:"My Profile", icon:Icons.Profile },
  { key:"onboarding", label:"Onboarding", icon:Icons.Onboarding },
  { key:"attendance", label:"Attendance", icon:Icons.Attendance },
  { key:"leave", label:"Leave Summary", icon:Icons.Leave },
  { key:"calendar", label:"Calendar", icon:Icons.Calendar },
  { key:"policies", label:"Policies", icon:Icons.Certificate },
  { key:"helpdesk", label:"Help Desk", icon:Icons.Settings || Icons.Chat },
  { key:"announcements", label:"Announcements", icon:Icons.Announcements },
  { key:"chat", label:"Chat", icon:Icons.Chat },
  { key:"notes", label:"Notes", icon:Icons.Edit || Icons.Chat },
  { key:"certificate", label:"Certificate", icon:Icons.Certificate },
];

// Defaults for loading states
const internData = { name:"", id:"", email:"", role:"", team:"", manager:"", startDate:"", endDate:"", progress:0 };
const checklist = [];
const onboardingDocs = [];
const attendance = { totalDays:0, present:0, leaves:0, holidays:0 };
const leaveSummary = [];
const calendarEvents = [];
const initLeaveReqs = [];
const initPermReqs = [];
const dailyAttendance = {};
const monthlyAttStats = {};
const notifications = [];
const chatMessages = [];
const internEmployees = [];
const initChats = [];
const profileDetails = [];
const uploadedDocs = [];

export { internData, checklist, onboardingDocs, attendance, leaveSummary, calendarEvents, initLeaveReqs, initPermReqs, dailyAttendance, monthlyAttStats, notifications, chatMessages, internEmployees, initChats, profileDetails, uploadedDocs, sidebarItems };
